import React, { useState } from 'react';

import Select from '../../Select';

import useStyles from '../styles';
import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

const SCALE_ITEMS = [
  { name: '0 - 10', value: '' },
  ...Array.from({ length: 11 }, (unused, index) => ({
    name: `${index}`,
    value: `${index}`,
  })),
];

function NpsQuestion({
  identifier, pages, info, handleDeleteQuestion, mode, handleDuplicateQuestion,
}) {
  const styles = useStyles();
  const [feedbackScale, setFeedbackScale] = useState('');

  const question = useQuestionForm({ identifier, pages, info });

  const handleFeedbackScale = (event) => {
    setFeedbackScale(Number.parseInt(event.target.value, 10));
  };

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.npsQuestionText.question"
      descriptionKey="task.taskEdition.npsQuestionText.description"
      disabled={!!info}
      editable
      actionsInGrid
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    >
      <Select
        name="feedbackOptions"
        className={styles.description}
        items={SCALE_ITEMS}
        value={info ? info.feedbackScale : feedbackScale}
        onChange={handleFeedbackScale}
        fullWidth
        disabled={!!info}
      />
    </QuestionShell>
  );
}

export default NpsQuestion;
